export function trapFocus() {
  let items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  const firstItem = items[0];
  const lastItem = items[items.length - 1];
  if (!firstItem || !lastItem) return;
  items.forEach((item, index) => {
    // On arrow down, move to the next item or the first item
    item.addEventListener('keydown', e => {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        const nextItem = items[index + 1] || firstItem;
        nextItem.focus();
      }
    });

    // On arrow up, move to the previous item or the last item
    item.addEventListener('keydown', e => {
      if (e.key === 'ArrowUp') {
        e.preventDefault();
        const previousItem = items[index - 1] || lastItem;
        previousItem.focus();
      }
    });
  });
  lastItem.addEventListener('keydown', e => {
    if (e.key === 'Tab' || e.keyCode === 9) {
      if (!e.shiftKey) {
        e.preventDefault();
        firstItem.focus();
      }
    }
  });
  firstItem.addEventListener('keydown', e => {
    if (e.key === 'Tab' || e.keyCode === 9) {
      if (e.shiftKey) {
        e.preventDefault();
        lastItem.focus();
      }
    }
  });
}